import { lazy } from 'react'
import { registerEditor } from '../editor-registry.js'

const LazyCollabExcelEditor = lazy(() =>
  import('../../ui/CollabExcelEditor.js').then(m => ({ default: m.CollabExcelEditor }))
)

const LazyCollabDocEditor = lazy(() =>
  import('../../ui/CollabDocEditor.js').then(m => ({ default: m.CollabDocEditor }))
)

const LazyCollabSlidesEditor = lazy(() =>
  import('../../ui/CollabSlidesEditor.js').then(m => ({ default: m.CollabSlidesEditor }))
)

/** Register the Collabora office editors. Called by office-registration.ts when
 *  Collabora is the active engine (synchronously — see there). */
export function registerCollaboraEditors(): void {
  // ─── Spreadsheets ────────────────────────────────────────────────────

  registerEditor({
    family: 'office-collabora',
    id: 'collabora-sheet',
    extensions: ['xlsx', 'xls', 'ods', 'fods', 'ots'],
    name: 'Spreadsheet Editor (Collabora)',
    component: LazyCollabExcelEditor,
    binaryExtensions: ['xlsx', 'xls', 'ods', 'fods', 'ots'],
  })

  // ─── Documents ───────────────────────────────────────────────────────

  registerEditor({
    family: 'office-collabora',
    id: 'collabora-doc',
    extensions: ['docx', 'doc', 'odt', 'fodt', 'ott', 'rtf'],
    name: 'Document Editor (Collabora)',
    component: LazyCollabDocEditor,
    binaryExtensions: ['docx', 'doc', 'odt', 'fodt', 'ott', 'rtf'],
  })

  // ─── Presentations ───────────────────────────────────────────────────

  registerEditor({
    family: 'office-collabora',
    id: 'collabora-slide',
    extensions: ['pptx', 'ppt', 'odp', 'fodp', 'otp'],
    name: 'Presentation Editor (Collabora)',
    component: LazyCollabSlidesEditor,
    binaryExtensions: ['pptx', 'ppt', 'odp', 'fodp', 'otp'],
  })
}
